import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';

@Component({
    selector: 'company-filter-drop-down',
    templateUrl: './company-filter-drop-down.component.html',
    styleUrls: ['./company-filter-drop-down.component.scss'],
})
export class CompanyFilterDropDown implements OnChanges {
    @Input() companies: { id: string; name: string }[] = [];
    @Input() selectedCompanyIds: string[] = [];
    /** REV-22155 — the tasks page shows "Mandant" (companies and persons). */
    @Input() labelKey = 'aumico_pm_tasks_company_filter_label';

    @Output() companyChange = new EventEmitter<string[]>();
    @Output() searchChange = new EventEmitter<string>();

    filterIsActive: boolean = false;

    openedFlyout = false;

    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedCompanyIds']) {
            this.updateFilterIsActive();
        }
    }

    private updateFilterIsActive(): void {
        this.filterIsActive = this.selectedCompanyIds?.length > 0;
    }

    onCompanySelection(value: string, checked: boolean) {
        if (checked) {
            this.selectedCompanyIds.push(value);
        } else {
            this.selectedCompanyIds = this.selectedCompanyIds.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8, // Adjusted to add a small gap
            right: rect.right,
            left: rect.left,
        };

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    toggleCompanySelection(companyId: string): void {
        const isCurrentlySelected = this.selectedCompanyIds.includes(companyId);
        this.onCompanySelection(companyId, !isCurrentlySelected);
    }

    applyFilter(): void {
        this.updateFilterIsActive();
        this.closeFlyout();
        this.companyChange.emit(this.selectedCompanyIds);
    }

    clearFilter(): void {
        this.selectedCompanyIds = [];
        this.updateFilterIsActive();
        this.closeFlyout();
        this.companyChange.emit(this.selectedCompanyIds);
    }

    onSearchFilterChange(event) {
        this.searchChange.emit(event);
    }
}
